import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/AuthContext";

function formatError(d) {
  if (!d) return "Something went wrong.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map(e => e?.msg || JSON.stringify(e)).join(" ");
  return d?.msg || String(d);
}

export function LoginPage() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setBusy(true);
    try {
      await login(email, password);
      nav("/app/capture");
    } catch (e2) {
      setErr(formatError(e2.response?.data?.detail) || e2.message);
    } finally { setBusy(false); }
  };

  return (
    <div className="cf-auth-wrap">
      <Link to="/" className="cf-auth-back" data-testid="auth-home-link">← back to riffmaster.com.au</Link>
      <div className="cf-auth-card" data-testid="login-card">
        <p className="cf-eyebrow">SIGN IN</p>
        <h1 className="cf-display cf-display--md">Welcome back.</h1>
        <p className="cf-lead cf-lead--muted">Pick up where you left your last riff.</p>
        <form onSubmit={submit} className="cf-auth-form">
          <label>Email<input type="email" value={email} onChange={e=>setEmail(e.target.value)} required data-testid="login-email"/></label>
          <label>Password<input type="password" value={password} onChange={e=>setPassword(e.target.value)} required data-testid="login-password"/></label>
          {err && <p className="cf-auth-err" data-testid="login-error">{err}</p>}
          <button className="cf-btn cf-btn--primary cf-btn--block" type="submit" disabled={busy} data-testid="login-submit">{busy ? "Signing in…" : "Sign in"}</button>
        </form>
        <p className="cf-auth-foot">No account? <Link to="/signup" data-testid="goto-signup">Create one</Link></p>
      </div>
    </div>
  );
}

export function SignupPage() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setBusy(true);
    try {
      await register(email, password, name);
      nav("/app/capture");
    } catch (e2) {
      setErr(formatError(e2.response?.data?.detail) || e2.message);
    } finally { setBusy(false); }
  };

  return (
    <div className="cf-auth-wrap">
      <Link to="/" className="cf-auth-back" data-testid="auth-home-link">← back to riffmaster.com.au</Link>
      <div className="cf-auth-card" data-testid="signup-card">
        <p className="cf-eyebrow">CREATE ACCOUNT</p>
        <h1 className="cf-display cf-display--md">Drop your first riff.</h1>
        <p className="cf-lead cf-lead--muted">Free forever: 5 uploads / month. Upgrade anytime.</p>
        <form onSubmit={submit} className="cf-auth-form">
          <label>Artist name (optional)<input type="text" value={name} onChange={e=>setName(e.target.value)} placeholder="e.g. @nova_drums" data-testid="signup-name"/></label>
          <label>Email<input type="email" value={email} onChange={e=>setEmail(e.target.value)} required data-testid="signup-email"/></label>
          <label>Password (6+ chars)<input type="password" value={password} onChange={e=>setPassword(e.target.value)} required minLength={6} data-testid="signup-password"/></label>
          {err && <p className="cf-auth-err" data-testid="signup-error">{err}</p>}
          <button className="cf-btn cf-btn--primary cf-btn--block" type="submit" disabled={busy} data-testid="signup-submit">{busy ? "Creating…" : "Create account"}</button>
        </form>
        <p className="cf-auth-foot">Already have an account? <Link to="/login" data-testid="goto-login">Sign in</Link></p>
      </div>
    </div>
  );
}
